export enum DistanceUnit {
    KM, MILE
}